var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24a.505.505 0 0 1-.171-.03L12 22.032 6.671 23.97A.501.501 0 0 1 6 23.5v-1.446c0-.52.264-.996.705-1.272L10 18.723v-6.484L.686 15.965a.505.505 0 0 1-.466-.05A.504.504 0 0 1 0 15.5v-.958a2.5 2.5 0 0 1 1.066-2.048L10 6.24V2c0-1.103.897-2 2-2s2 .897 2 2v4.24l8.934 6.253A2.503 2.503 0 0 1 24 14.542v.958a.501.501 0 0 1-.686.464L14 12.238v6.484l3.295 2.06c.441.277.705.752.705 1.272V23.5a.503.503 0 0 1-.5.5zM12 21a.5.5 0 0 1 .171.03L17 22.786v-.732a.498.498 0 0 0-.235-.424l-3.53-2.206A.5.5 0 0 1 13 19v-7.5a.501.501 0 0 1 .686-.464L23 14.762v-.22c0-.489-.239-.948-.64-1.229L13.213 6.91A.503.503 0 0 1 13 6.5V2c0-.551-.449-1-1-1s-1 .449-1 1v4.5c0 .163-.08.316-.213.41L1.64 13.313A1.5 1.5 0 0 0 1 14.542v.22l9.314-3.726A.501.501 0 0 1 11 11.5V19a.5.5 0 0 1-.235.424l-3.53 2.206a.498.498 0 0 0-.235.424v.732l4.829-1.756A.5.5 0 0 1 12 21z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.80569e58e63712ae7b0a9c7813f457c2.svg";
export { ForwardRef as ReactComponent };